import {BRAND_LIST, CATEGORY_LIST, GST_LIST, HSN_LIST, CREATE_DELETE_BRAND, CREATE_DELETE_CATEGORY, CREATE_DELETE_HSN, BUSINESS_ITEM_LIST, GET_DROPDOWN_DATA, FETCH_BRAND_HSN} from "./type";

const initalState = {
  brandList: [],
  categoryList: [],
  gstList: [],
  hsnList: [],
  businessItemList: [],
  dropdownData: [],
  brandAndHsnData: [],
};

const businessItemReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case BRAND_LIST:
      return {
        ...state,
        brandList: payload,
      };
    case CATEGORY_LIST:
      return {
        ...state,
        categoryList: payload,
      };
    case GST_LIST:
      return {
        ...state,
        gstList: payload,
      };
    case HSN_LIST:
      return {
        ...state,
        hsnList: payload,
      };
    case BUSINESS_ITEM_LIST:
      return {
        ...state,
        businessItemList: payload,
      };
    case GET_DROPDOWN_DATA:
      return {
        ...state,
        dropdownData: payload,
      };
    case FETCH_BRAND_HSN:
      return {
        ...state,
        brandAndHsnData: {
          ...state.brandAndHsnData,
          ...(payload?.brand ? { brand: payload.brand } : {}),
          ...(payload?.hsn ? { hsn: payload.hsn } : {}),
        },
      };  
    default:
      return {
        ...state,
      };
  }
};

export default businessItemReducer;
